import { render, staticRenderFns } from "./DashboardStats.vue?vue&type=template&id=aabebd32&scoped=true&"
import script from "./DashboardStats.vue?vue&type=script&setup=true&lang=js&"
export * from "./DashboardStats.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DashboardStats.vue?vue&type=style&index=0&id=aabebd32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabebd32",
  null
  
)

export default component.exports